import React from "react";
import Select from "react-select";
import { Tooltip } from "react-tooltip";

const DashboardSearchSelect = ({
  name,
  value,
  onChange,
  labelClass,
  inputClass,
  errorClass,
  error,
  label,
  isRequired,
  options,
  isMulti,
  defaultValue,
  isDisabled,
  placeholder,
}) => {
  const customStyles = {
    singleValue: (provided, state) => ({
      ...provided,
      backgroundColor: state.isDisabled ? "#E7E7E7" : provided.backgroundColor,
      color: state.isDisabled ? "#626262" : provided.color,
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: state.isDisabled ? "#E7E7E7" : provided.backgroundColor,
      color: state.isDisabled ? "#626262" : provided.color,
      boxShadow: "none !important",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0px 4px", // ensures text sits nicely inside
    }),
    placeholder: (base) => ({
      ...base,
      margin: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      paddingRight: 6,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: 0,
    }),
    // menu portal / menu styles if you want menu width to match control
    menu: (base) => ({ ...base, width: "100%" }),
    menuList: (base) => ({ ...base, padding: 0 }),
  };

  const trimClientName = (clientName, maxLength = 25) => {
    if (!clientName) return "";

    const trimmed = clientName.trim();
    return trimmed.length > maxLength
      ? trimmed.slice(0, maxLength).trim() + "..."
      : trimmed;
  };

  const finalOptions = options.map((itm) => ({
    value: itm.value,
    label: (
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          data-tooltip-id={`tip-${itm.value}`}
          data-tooltip-content={itm.label}
          data-tooltip-place="left"
        >
          {trimClientName(itm.label)}
        </div>

        {/* Tooltip must be outside menu clipping → use fixed positioning */}
        <Tooltip
          id={`tip-${itm.value}`}
          className="tooltip-custom"
          positionStrategy="fixed"
          style={{
            maxWidth: "180px",
            whiteSpace: "normal",
            userSelect: "text",
            zIndex: 999999,
            padding: "8px",
            wordWrap: "break-word",
          }}
        />
      </div>
    ),
  }));

  const CustomSingleValue = (props) => {
    const { data } = props;

    return (
      <>
        <div
          data-tooltip-id={`tip-selected-${data.value}`}
          data-tooltip-content={data.label}
          data-tooltip-place="left"
          style={{ position: "absolute", padding: "8px" }}
        >
          {data.label}
        </div>
        <Tooltip
          id={`tip-selected-${data.value}`}
          className="tooltip-custom"
          positionStrategy="fixed"
          style={{
            maxWidth: "180px",
            whiteSpace: "normal",
            userSelect: "text",
            zIndex: 999999,
            padding: "8px",
            wordWrap: "break-word",
          }}
        />
      </>
    );
  };

  return (
    <>
      {label && (
        <label htmlFor={name} className={`c-label ${labelClass}`}>
          {label} {isRequired && <span className="asterisk f-12">&#42;</span>}
        </label>
      )}
      <div className={`position-relative${isDisabled && " cursor-na"}`}>
        <Select
          className={`${inputClass} ${error ? "error" : ""}`}
          isMulti={isMulti}
          classNamePrefix="select"
          isSearchable={true}
          options={finalOptions}
          name={name}
          defaultValue={defaultValue}
          isDisabled={isDisabled}
          value={options && options.find((itm) => itm.value === value)}
          onChange={onChange}
          maxMenuHeight={200}
          isRequired={isRequired}
          placeholder={placeholder}
          styles={customStyles}
          // remove the vertical separator
          components={{
            IndicatorSeparator: () => null,
            SingleValue: CustomSingleValue,
          }}
          // menuPlacement="auto"
        />
      </div>
      {error && <div className={`invalid ${errorClass}`}>{error}</div>}
    </>
  );
};

export default DashboardSearchSelect;
